import ErrorMessage, { getGlobalErrorCode as getGlobalError } from './ErrorMessage';

export const getGlobalErrorCode = getGlobalError;
export default ErrorMessage;
